import type { GuildEventStatus } from "@/core/guild-events/types"

import { Badge } from "@/components/ui/badge"
import { getStatusLabel } from "@/core/guild-events/labels"

const STATUS_VARIANT: Record<
  GuildEventStatus,
  "default" | "secondary" | "destructive" | "outline"
> = {
  scheduled: "secondary",
  closed: "outline",
  cancelled: "destructive",
  started: "default",
  archived: "outline",
  announcement_missing: "destructive",
}

export function EventStatusBadge({ status }: { status: GuildEventStatus }) {
  return (
    <Badge variant={STATUS_VARIANT[status]}>{getStatusLabel(status)}</Badge>
  )
}
